import { render } from "./ListPager.vue?vue&type=template&id=1da8df28&scoped=true"
import script from "./ListPager.vue?vue&type=script&lang=js"
export * from "./ListPager.vue?vue&type=script&lang=js"

import "./ListPager.vue?vue&type=style&index=0&id=1da8df28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da8df28"]])

export default __exports__